module.exports = __webpack_public_path__ + "img/property-monk.67c238e8.jpeg";